
























import Vue from 'vue'
import { TextWithInfoInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TextWithInfoEl',
  props: {
    templateItemData: {
      type: Object as () => TextWithInfoInterface,
      required: true
    }
  },
  computed: {
    separatorStyle (): string {
      return 'border-bottom: 1px solid ' + this.templateItemData.separator + ';'
    }
  }
})
